import React, {useState} from "react";
import {Button, Input, Form, Col, Row} from "antd";
import { addPCContractor} from "../../../api";

function AddPCContractorDialog ({ onClose, setPCContractors}) {
    const [form] = Form.useForm();
    const [name, setName] = useState(null);

    const onNameChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            setName(value);
        }
    }
    const onSubmit = async (values) => {
        let response = await addPCContractor(name);
        if(response !== null && response.data !== null)
            setPCContractors(response.data);
        onClose();
    }
    return (
        <div className='react-confirm-alert-body'>
            <h4>{'Add New PC Contractor'}</h4>
            <section>
                <Form
                    form={form}
                    style={{ padding: '1rem 1rem' }}
                    onFinish={(values) => onSubmit(values)}
                >
                    <div style={{ top: 15, position: 'relative' }}>
                        <Row justify='center' align='middle'>
                            <Col sm={24} style={{ alignItems: 'end' }}>
                                <Form.Item
                                    label='PC Contractor Name'
                                    name='roleName'
                                    initialValue={name}
                                    labelCol={{ span: 5 }}
                                    style={{fontWeight:'bolder'}}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter name!'
                                        }                                ]}
                                >
                                    <Col>
                                        <Input
                                            id='name'
                                            size='small'
                                            value={name}
                                            placeholder='PC Contractor Name'
                                            onChange={onNameChange}
                                        />
                                    </Col>
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <Button
                            className='btn btn-primary start-5'
                            type='primary' htmlType='submit'
                        >
                            Save Changes
                        </Button>
                        <Button className='btn btn-primary start-5' type='primary' onClick={onClose}>
                            Cancel
                        </Button>{' '}
                    </div>
                </Form>
            </section>
        </div>
  )
}

export default AddPCContractorDialog;